import logoImage from "@/assets/logo.png";

interface LogoProps {
  className?: string;
}

const Logo = ({ className = "" }: LogoProps) => {
  return (
    <div className={`flex items-center ${className}`}>
      <img 
        src={logoImage} 
        alt="VRxED Logo" 
        className="h-8 md:h-10 w-auto brightness-0 invert"
      />
    </div>
  );
};

export default Logo;
